import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import { Alert } from 'react-bootstrap'
import { FormattedList, FormattedMessage, useIntl } from 'react-intl'
import { SAVE_STEP_LABEL_IDS, SAVE_STEPS } from '../../saveSteps'

const SAVE_STEP_VALUES = Object.values(SAVE_STEPS)
const NO_STEPS = []

const propTypes = {
  /**
   * Save step still running after polling stopped
   */
  processingStep: PropTypes.oneOf(SAVE_STEP_VALUES),
  /**
   * Save steps that weren't sent because they come after the one still running
   */
  notSentSteps: PropTypes.arrayOf(PropTypes.oneOf(SAVE_STEP_VALUES)),
}

function UnfinishedSaveAlert({ processingStep = null, notSentSteps = NO_STEPS }) {
  const intl = useIntl()
  const notSentLabels = useMemo(
    () => notSentSteps.map((step) => intl.formatMessage({ id: SAVE_STEP_LABEL_IDS[step] })),
    [intl, notSentSteps],
  )

  return (
    <Alert variant="info" className="mb-0">
      {/* One wrapper, so the alert's flex layout stacks the lines instead of putting them in columns */}
      <div className="alert-text">
        <div>
          <FormattedMessage id="GENERAL.PROCESSING_IN_BACKGROUND" />
        </div>
        {processingStep && (
          <div className="mt-2">
            <FormattedMessage
              id="EDIT_EMPLOYEE.SAVE_STILL_PROCESSING_STEP"
              values={{ step: <FormattedMessage id={SAVE_STEP_LABEL_IDS[processingStep]} /> }}
            />
          </div>
        )}
        {notSentLabels.length > 0 && (
          <div className="mt-2">
            <FormattedMessage
              id="EDIT_EMPLOYEE.SAVE_STEPS_NOT_SENT"
              values={{ steps: <FormattedList type="conjunction" value={notSentLabels} /> }}
            />
          </div>
        )}
      </div>
    </Alert>
  )
}

UnfinishedSaveAlert.propTypes = propTypes

export default React.memo(UnfinishedSaveAlert)
